import React, { FC } from "react";
import cx from "classnames";
import ReactModal from "react-modal";
import { CloseIconSvg } from "../../icons";
import { StyledCloseButton, StyledModal, StyledOverlay } from "./index.styled";

export interface SimpleModalProps {
  children?: JSX.Element;
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
}

export const SimpleModal: FC<SimpleModalProps> = ({
  children,
  isOpen,
  onClose,
  className,
}) => {
  return (
    <ReactModal
      ariaHideApp={false}
      className={cx("_", className)}
      contentElement={(props, children) => (
        <StyledModal {...props}>{children}</StyledModal>
      )}
      isOpen={isOpen}
      overlayClassName="_"
      overlayElement={(props, contentElement) => (
        <StyledOverlay {...props}>{contentElement}</StyledOverlay>
      )}
    >
      {children}
      {onClose && (
        <StyledCloseButton
          onClick={() => onClose()}
          aria-label="Close"
          role="button"
        >
          <CloseIconSvg />
        </StyledCloseButton>
      )}
    </ReactModal>
  );
};
